export default "__VITE_ASSET__53148353__"